export { SettingsPageHeaderTemplate } from './SettingsPageTemplate'
export type { SettingsPageHeaderTemplateProps } from './SettingsPageTemplate.types'
